import { CardioOrResistance, WorkoutSettings } from 'fitbeat.gym-core';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import BodyWeightIcon from '../../assets/images/bodyweight-man.svg';
import BuildIcon from '../../assets/images/build.svg';
import BurnIcon from '../../assets/images/burn.svg';
import Theme from '../../theme';
import { BalanceIcon } from '../../ui/components/Icons';
import {
  mappedSkillLevelSvgs,
  mappedSkillLevelTitle,
} from '../../ui/components/SkillLevelList';
import { getBodyGroupText } from '../../utils';
import { defaultScale } from '../../utils/scaling';

const iconWidth = defaultScale(20);
const iconHeight = defaultScale(20);

interface IProps {
  workoutSettings: WorkoutSettings;
  overrideStyles: any;
  t(key: string, options?: any): string;
}

export const InviterSettingsRow = ({
  t,
  workoutSettings,
  overrideStyles,
}: IProps) => {
  const fillSecondary = Theme.BLACK;
  const fill = Theme.BLACK;

  const mappedWorkoutType = {
    [CardioOrResistance.Cardio]: {
      title: t('burn'),
      svg: (
        <BurnIcon
          width={iconWidth}
          height={iconHeight}
          fillSecondary={fillSecondary}
        />
      ),
    },
    [CardioOrResistance.Resistance]: {
      title: t('build'),
      svg: (
        <BuildIcon
          width={iconWidth}
          height={iconHeight}
          fillSecondary={fillSecondary}
        />
      ),
    },
    [CardioOrResistance.Balance]: {
      title: t('balance'),
      svg: (
        <BalanceIcon
          width={iconWidth}
          height={iconHeight}
          color={fillSecondary}
        />
      ),
    },
  };
  return (
    <View style={styles.rowContainer}>
      <View
        style={[
          styles.iconAndTextContainer,
          overrideStyles.iconAndTextContainer,
        ]}
      >
        {mappedSkillLevelSvgs[workoutSettings.level](
          iconWidth,
          iconHeight,
          fill,
          fillSecondary,
        )}
        <Text style={[styles.iconText, overrideStyles.color]}>
          {mappedSkillLevelTitle[workoutSettings.level].alt}
        </Text>
      </View>
      <View
        style={[
          styles.iconAndTextContainer,
          overrideStyles.iconAndTextContainer,
        ]}
      >
        {mappedWorkoutType[workoutSettings.cardioOrResistance].svg}
        <Text style={[styles.iconText, overrideStyles.color]}>
          {mappedWorkoutType[workoutSettings.cardioOrResistance].title}
        </Text>
      </View>
      <View
        style={[
          styles.iconAndTextContainer,
          styles.iconAndTextContainer,
          { borderRightWidth: 0 },
        ]}
      >
        <BodyWeightIcon
          width={iconWidth}
          height={iconHeight}
          fillSecondary={fillSecondary}
        />
        <Text style={[styles.iconText, overrideStyles.color]}>
          {getBodyGroupText(workoutSettings.threeBodyGroups)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginVertical: defaultScale(15),
  },
  iconAndTextContainer: {
    alignItems: 'center',
    flex: 1,
    borderRightWidth: 1,
  },
  iconText: {
    ...Theme.textStyle.bodyCopyReg,
  },
});
